var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3057_12837)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_3057_12837)",
    d: "m20.84 7.54-.65-2.61A2.544 2.544 0 0 0 17.72 3H6.23c-1.18 0-2.19.79-2.48 1.93L3.1 7.54c-.25 1-.03 2.04.6 2.85.03.04.08.08.12.12v6.67c0 1.78 1.45 3.23 3.23 3.23h9.84c1.78 0 3.23-1.45 3.23-3.23v-6.67s.08-.07.12-.12c.63-.81.85-1.85.6-2.85m-10.57 8.4c0-.45.18-.88.5-1.2s.75-.5 1.2-.5.88.18 1.2.5.5.75.5 1.2v2.93h-3.39v-2.93zm3.98-2.28c-.61-.61-1.42-.94-2.28-.94s-1.67.34-2.28.94c-.61.61-.94 1.42-.94 2.28v2.93H7.06c-.93 0-1.7-.76-1.7-1.7V11.5c.31.1.63.16.97.16 1.04 0 1.96-.49 2.56-1.25.63.76 1.57 1.25 2.63 1.25h.89c1.06 0 2-.5 2.64-1.26.6.76 1.52 1.26 2.57 1.26.34 0 .66-.07.97-.16v5.67c0 .93-.76 1.7-1.7 1.7h-1.7v-2.93c0-.86-.34-1.67-.94-2.28M4.91 9.45c-.34-.44-.46-1-.33-1.54l.65-2.61c.11-.45.52-.77.99-.77h1.85v3.86c0 .97-.79 1.76-1.76 1.76-.45 0-.86-.17-1.19-.46l-.03-.03c-.07-.07-.14-.13-.2-.21zm13.91.21-.02.02c-.33.29-.75.46-1.19.46-.97 0-1.76-.79-1.76-1.76V4.53h1.86c.47 0 .88.32.99.77l.65 2.61c.13.54.02 1.1-.33 1.54-.06.08-.13.14-.21.21zm-4.5-1.43c0 1.05-.86 1.91-1.91 1.91h-.89a1.9 1.9 0 0 1-1.9-1.84V4.53h4.71v3.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3057_12837",
    x1: 11.97,
    x2: 11.97,
    y1: 3,
    y2: 20.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1A60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3057_12837"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h17.94v17.4H3z"
  })))));
};
export default SvgStore;